exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation-logo[data-v-7afb5930]{width:600px;margin:auto}@media screen and (max-width:600px){.animation-logo[data-v-7afb5930]{width:300px;margin:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7afb5930","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/animations/Logo.vue
// module id = 417
// module chunks = 0